module.exports = __webpack_public_path__ + "static/media/youtube.1ff5f219.svg";